<ziro-loading-block [hidden]="!isSaving || modalProperties()"></ziro-loading-block>
@if (!isSaving || modalProperties()) {
  <div data-automation="ziro-voicemail-form" class="container-fluid">
    @for (fieldId of fieldGroups.textInputs; track fieldId) {
      <ziro-text [fieldId]="fieldId"></ziro-text>
    }
    <ziro-select [fieldId]="'voicemailTemplate'"></ziro-select>
    <ziro-multi-text [fieldId]="'alternateExtensions'"></ziro-multi-text>
    <ziro-text [fieldId]="'smtpNotificationDevice'"></ziro-text>
  </div>
}
<div class="py-2 px-3 d-flex justify-content-end align-items-center">
  @if (!username() && !modalProperties()) {
    <div>
      <ziro-button
        class="me-1"
        [dataAutomation]="'delete-voicemail-button'"
        (click)="handleDeleteClick()"
        [isDisabled]="isPending || !isExistingVoicemail"
        [iconPending]="ziroIcons.SAVING"
        [isPending]="isDeleting"
        [buttonStyle]="buttonStyles.DANGER"
        [label]="'tkey;dialogs.button.delete'"
      ></ziro-button>
      <ziro-submit-button
        [isPending]="isPending"
        [isDisabled]="!isFormValid() || isPending"
        [label]="'tkey;global.button.save.text'"
        [dataAutomation]="'save-voicemail-button'"
        [icon]="ziroIcons.SAVE_SUCCESS"
        [iconPending]="ziroIcons.SAVING"
        [formSubmitSubject]="_validateAndSubmitSource"
      ></ziro-submit-button>
    </div>
  }
</div>
